import Vue from 'vue'
import App from './App.vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/index.scss';
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(ElementUI);
const loadimage = require("@/assets/home/home.png")
const errorimage = require("@/assets/home/home.png")

//注册图片懒加载  
Vue.use(VueLazyload, {
  error: loadimage,//图片错误的替换图片路径(可以使用变量存储)
  loading: errorimage,//正在加载的图片路径(可以使用变量存储)
})

new Vue({
  render: h => h(App),
}).$mount('#app')
